import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import * as _ from 'lodash';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Footer, PrimeTemplate } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { TooltipModule } from 'primeng/tooltip';

import { UserActivitiesService } from '../user-activities.service';

declare var $: any;

@Component({
    selector: 'hour-pop',
    templateUrl: 'activity-hourPopup.component.html',
    standalone: true,
    imports: [DialogModule, PrimeTemplate, TooltipModule, DropdownModule, FormsModule, MultiSelectModule, Footer, TranslateModule]
})
export class ActivityHourPopUpComponent implements OnInit {
  private service = inject(UserActivitiesService);
  private translate = inject(TranslateService);


  activities: any[];
  typologyList: any[];
  selectedTypologies = [];

  state: string = "Week";
  status: string;

  typterm: string;

  data: string;
  display: boolean = false;
  periodOptions: any

  @Input() idx: number;
  @Input() params: any;

  @Output() closepopup: EventEmitter<boolean> = new EventEmitter();
  @Output() saveData: EventEmitter<{ params: any, indx: number }> = new EventEmitter();

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {

    this.periodOptions = [
      { name: this.translate.instant('widgets.party-activities.Week'), value: 'Week' },
      { name: this.translate.instant('widgets.party-activities.Day'), value: 'Day' },
      { name: this.translate.instant('widgets.party-activities.Month'), value: 'Month' }
    ];
  }

  ngOnInit(): void {
    this.state = null;
    this.data = "Week";

    if (this.params) {
      if (this.params.state)
        this.state = this.params.state;

      if (this.params.date)
        this.data = this.params.date;
    }


    this.service
      .getActivityTypologies()
      .subscribe(typ => {
        this.typologyList = typ;
        // TODO:  CONTROLLO TIPOLOGIE CHE ARRIVANO DAI PARAMS
      });

    this.display = true;
  }

  getData(name: string) {
    return 'widgets.party-activities.' + name;
  }

  cancel() {
    this.closepopup.next(true);
  }

  clearDefault() {
    this.state = null;
    this.data = "Week";

    this.service
      .getActivityTypologies()
      .subscribe(typ => {
        this.typologyList = typ;
        this.typologyList.forEach(t => {
          t.selected = false;
        })
        this.selectedTypologies = [];
      })
  }

  confirm() {
    let typologies = null;

    if (this.selectedTypologies.length > 0)
      typologies = this.selectedTypologies;

    let parms = {
      state: this.state,
      date: this.data,
      typologies: typologies
    }

    this.saveData.next({ params: parms, indx: this.idx });
    this.display = false;
    this.closepopup.next(true);
  }
}
